import Icon from '@components/Icon';
import Txt from '@primitive/Txt';
import { FieldErrors as FieldErrorsType } from '@formie/useForm';
import { Collapse, List, ListItem, ListItemIcon } from '@primitives';

export type FieldErrorsProps = {
  errors?: FieldErrorsType;
};

export const FieldErrors = ({ errors = [] }: FieldErrorsProps) => {
  return (
    <Collapse in={!!errors.length} unmountOnExit>
      <List component="ul" disablePadding sx={{ marginY: 1 }}>
        {errors.map((v, i) => (
          <ListItem key={i} disableGutters>
            <ListItemIcon sx={{ minWidth: 25 }}>
              <Icon name="error" color="error" />
            </ListItemIcon>
            {/* <ListItemText>{v}</ListItemText> */}
            <Txt variant="small" as="span">
              {v}
            </Txt>
          </ListItem>
        ))}
      </List>
    </Collapse>
  );
};
